import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const NotFound = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-blackC flex items-center justify-center px-4">
      <div className="text-center max-w-2xl mx-auto">
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-9xl md:text-[12rem] font-display text-primary leading-none mb-4" style={{ fontFamily: '"Lobster", cursive' }}>
            404
          </h1>
          <div className="w-32 h-1 bg-gradient-to-r from-transparent via-primary to-transparent mx-auto"></div>
        </div>

        {/* Message */}
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-display text-cream mb-4">
            {language === 'en' ? 'Page Not Found' : 'الصفحة غير موجودة'}
          </h2>
          <p className="text-gray-silver text-lg mb-6 leading-relaxed">
            {language === 'en'
              ? "Sorry, the page you're looking for doesn't exist or has been moved."
              : 'عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها.'}
          </p>
        </div>

        {/* Countdown */}
        <div className="mb-8">
          <div className="inline-flex items-center gap-3 px-6 py-4 bg-dark border border-gray-dark rounded-xl">
            <svg className="w-6 h-6 text-primary animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            <p className="text-gray-light">
              {language === 'en' ? 'Redirecting to home page in' : 'سيتم إعادة التوجيه إلى الصفحة الرئيسية خلال'}
            </p>
            <span className="text-primary font-display text-2xl font-bold min-w-[2rem]">
              {countdown}
            </span>
            <span className="text-gray-silver">
              {language === 'en' ? 'seconds' : 'ثانية'}
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => navigate('/')}
            className="px-8 py-4 bg-gradient-to-r from-primary to-primary-light text-blackC font-semibold rounded-lg hover:shadow-lg hover:shadow-primary/20 transition-all flex items-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            {language === 'en' ? 'Go to Home' : 'الذهاب إلى الصفحة الرئيسية'}
          </button>
          <button
            onClick={() => navigate(-1)}
            className="px-8 py-4 bg-dark border border-gray-dark text-cream font-semibold rounded-lg hover:bg-charcoal hover:border-primary/30 transition-all flex items-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            {language === 'en' ? 'Go Back' : 'العودة'}
          </button>
        </div>

        {/* Decorative Elements */}
        <div className="mt-16 flex justify-center gap-2">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className="w-2 h-2 rounded-full bg-primary/30 animate-pulse"
              style={{ animationDelay: `${i * 0.2}s` }}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotFound;

